export const DINE_IN_TEXT = 'Dine-In';
export const DELIVERY_TEXT = 'Home Delivery';
export const TABLE_ORDERS_TEXT = 'Table Orders';
export const ROOM_SERVICE_TEXT = 'Room Service';
export const PAID_TEXT = 'Paid';
export const UNPAID_TEXT = 'Unpaid';
export const PAYMENT_CANCELLED_TEXT = 'Payment Declined';
export const PAYMENT_FAILED_TEXT = 'Payment Failed';
export const PAYMENT_TEXT = 'Payment';
export const MARK_PAID_TEXT = 'Mark Paid';
export const TOTAL_TEXT = 'Total';
export const SEE_MORE_TEXT = 'See More >';
export const MORE_TEXT = 'more';
export const ORDERED_TEXT = 'Ordered';
export const ORDERED_AT_TEXT = 'Order Time:';
export const TABLE_TEXT = 'Table';
export const MERGED_TEXT = 'Merged';
export const ORDER_FOR_TEXT = 'Order for ';
export const AGO_TEXT = 'ago';
export const NO_ORDER_TEXT = 'Order list is empty';
export const NO_ORDER_DINE_IN_TEXT =
	'Print the QR code using the My Rasoi app, and let your customers order directly!';
export const NO_ORDER_DELIVERY_TEXT =
	'Share the QR code from My Rasoi app with your customers, and let them order directly!';
export const EDIT_ITEM_TEXT = 'Edit Item';
export const ADD_NEW_ITEM_TEXT = 'Add New Item';
export const ADD_TEXT = 'Add';
export const EDIT_TEXT = 'Edit';
export const ITEMS_LIST_TEXT = 'Items List';
export const THERE_ARE_NO_ITEMS_TEXT = 'There are no items in the list';
export const EDIT_ORDER = 'Edit Order';
export const ADD_EXTRA_CHARGE_TEXT = 'Add Extra Charges';
export const EXTRA_CHARGES_TEXT = 'Extra Charges';
export const THERE_ARE_NO_CHARGES_TEXT = 'There are no charges added';
export const REMOVE_TEXT = 'Remove';
export const PRICE_PER_ITEM_TEXT = 'Price per Item';
export const ITEM_NAME_TEXT = 'Item Name';
export const NEW_DISH_PLACEHOLDER = 'Enter name of the dish';
export const CHARGE_VALUE_TEXT = 'Charges';
export const CHARGE_NAME_TEXT = 'Charge Name';
export const FLAT_CHARGE_TEXT = 'Flat Charge (in #currency)';
export const PERCENTAGE_TEXT = 'Percentage (in %)';
export const ADD_NEW_CHARGE_TEXT = 'Add New Charge';
export const EDIT_CHARGE_TEXT = 'Edit Charge';
export const MERGE_ORDER_ERROR_TEXT = 'Are you sure you want to merge {#billCount#} bills?';
export const MERGE_BILL_TEXT = 'Merge Bill';
export const MERGE_TEXT = 'Merge';
export const SEARCH_ORDER_TEXT = 'Table Number or Customer Name';
export const ROOM_SEARCH_ORDER_TEXT = 'Customer or Room Name';
export const GENERAL_SEARCH_ORDER_TEXT = 'Search by Customer Name';
export const SELECT_ANOTHER_ORDER_TEXT = 'Please select atleast 2 orders to merge';
